export default __webpack_public_path__ + "static/media/ElephantPage2.0d65d416.txt";